import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { Transition } from '@headlessui/react';
import Button from 'partial/components/Button';
import PageWrapper from 'partial/components/PageWrapper';
import NetworkGraph from 'partial/dashboard/NetworkGraph';

const CATEGORY_LABEL_BY_GROUP = {
  main: 'Main',
  category: 'Category',
  channel: 'Channel',
};

const Selected = ({ data }) => {
  const [value, setValue] = React.useState(data);
  React.useEffect(() => {
    if (!data?.data?.id) return;
    setValue(data);
  }, [data]);
  const history = useHistory();
  const handleMoreInfo = () => {
    history.push({
      pathname: '/channels/profile',
      state: {
        selected: data,
      },
    });
  };
  const children = value?.children || [];
  return (
    <Transition
      as={Fragment}
      show={!!data?.data?.id}
      enter="ease-out duration-300"
      enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      enterTo="opacity-100 translate-y-0 sm:scale-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100 translate-y-0 sm:scale-100"
      leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    >
      <div className="absolute p-6 z-10">
        <div className="bg-white p-3 border rounded-lg shadow-lg w-64 space-y-2">
          <div>
            <div className="text-lg font-bold leading-snug">
              {value?.data?.label || '-'}
            </div>
            <div className="text-gray-500 leading-snug">
              {CATEGORY_LABEL_BY_GROUP[value?.data?.group]}
            </div>
          </div>
          {children.length > 0 ? (
            <ul className="list-disc pl-6">
              {children.map((row) => (
                <li key={row.id}>{row?.label}</li>
              ))}
            </ul>
          ) : null}
          {value?.data?.group === 'channel' ? (
            <div className="flex justify-center">
              <Button size="sm" onClick={handleMoreInfo}>
                More Info
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </Transition>
  );
};

Selected.defaultProps = {
  data: null,
};

Selected.propTypes = {
  data: PropTypes.instanceOf(Object),
};

function CategoryDiagram() {
  const [selected, setSelected] = React.useState(null);
  return (
    <PageWrapper>
      <div className="pb-5 border-b border-gray-200">
        <h3 className="text-lg leading-6 font-medium text-gray-900">Diagram</h3>
      </div>
      <div className="bg-white rounded-lg shadow-lg h-[600px] relative">
        <Selected data={selected} />
        <NetworkGraph onClick={setSelected} />
      </div>
    </PageWrapper>
  );
}

CategoryDiagram.propTypes = {};

export default CategoryDiagram;
